export default "__VITE_ASSET__8qhe$vXM__"